import type { Variants } from 'framer-motion';

/**
 * Shared motion variants for the admin app. Mirrors apps/website/lib/motion.ts
 * but tuned (shorter durations) for the denser admin UI - staff should never
 * wait on chrome to settle before they can act.
 */

const ease = [0.16, 1, 0.3, 1] as const;

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease } },
};

export const stagger: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.06 } },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.3, ease } },
};
